import Form from '../../../../../form_builder_2/form';

export default class VinLookupSubview {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.vin-lookup-subview');
        this.formEl = parent.el.querySelector('.service-plan-form');
        this.form = new Form(this.formEl, {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
        this.templateSettings = { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g };
        this.template = _.template(parent.el.querySelector('#service-plan-vin-lookup-result-template').innerHTML.replaceAll('\\', ''), this.templateSettings);
        this.resultEl = this.el.querySelector('.result');
        this.infoContainer = this.el.querySelector('.info-container');
        this.infoHeading = this.el.querySelector('.info-heading');
        this.bind();
    }

    bind() {
        this.infoHeading?.addEventListener('click', (e) => {
            e.preventDefault();
            if (e.target.closest('.info-heading')) {
                this.infoContainer?.classList.toggle('active');
            }
        });
    }

    populate(data) {
        this.resultEl.innerHTML = this.template({result: data});
        this.bindCTA(data);
    }

    bindCTA(data) {
        const searchedCarCTAs = this.el.querySelector('.searched-car-cta');
    
        searchedCarCTAs?.addEventListener('click', (e)=> {
            this.onSelect(data);
        });
    }

    onSelect(data) {
        this.parent.result = data; //Set data of chosen car into parent result to be rendered on results screen.
    }

    onSuccess(result) {
        this.resultEl.classList.remove('hide');
        this.result = result?.data;
        this.populate(this.result);
    }

    onError(result) {
        this.form.showError();
        this.resultEl.classList.add('hide');
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }
}
